// import TicketMenuManagementCreate from "./lib/create";
import ReservationTable from './lib/table';
import { useTypedSelector } from 'common/hooks/useTypedSelector';
import AppLoading from 'components/appLoading';
import ReservationCounts from './lib/reservationCounts';

import PageTitle from 'components/pageTitle';

import * as S from './styles';

export default function ReservationPage() {
  const { reservations, statistics }: any = useTypedSelector((state) => state.Reservation);

  return (
    <S.Container>
      {/* The heading is drawn by the topbar. The counts are a summary of the
          table below them, so they sit above it as their own card rather than
          floating in a head row beside a title that is no longer there. */}
      <PageTitle title="Reservation System" />

      <ReservationCounts data={statistics.data} />

      <ReservationTable data={reservations.data} loading={reservations.loading} />

      <AppLoading loading={statistics.loading || reservations.loading} />
    </S.Container>
  );
}
